import { render } from "./Title.vue?vue&type=template&id=1f0e2d36&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=1f0e2d36&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1f0e2d36"

export default script